import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './VimeoEmbed.module.scss'

const VimeoEmbed = ({ src }) => {
  const { t } = useTranslation()

  return (
    <div className={classNames('embed-responsive embed-responsive-16by9', classes.embed)}>
      <iframe
        className='embed-responsive-item'
        src={src}
        title={t('certificationBuilder.lesson.videoPreview')}
        allow='fullscreen; picture-in-picture'
        allowFullScreen
      />
    </div>
  )
}

VimeoEmbed.propTypes = {
  src: PropTypes.string.isRequired,
}

export default VimeoEmbed
